import React from 'react';
import { Flex, Spin, theme } from 'antd';

type SpinningWheelProps = {
  matchParent?: boolean;
};

const SpinningWheel = ({ matchParent = false }: SpinningWheelProps) => {
  const { token } = theme.useToken();
  return (
    <Flex
      justify="center"
      align="center"
      style={{
        padding: token.paddingXS,
        ...(matchParent ? { marginBlock: token.margin } : { height: '100vh' }),
      }}
    >
      <Spin size="large" />
    </Flex>
  );
};

export default SpinningWheel;
